<app-navbar *ngIf="authService.isLoggedIn()"></app-navbar>
<ngx-spinner type="square-jelly-box"></ngx-spinner>
<div [ngStyle]="{'margin-top': authService.isLoggedIn() ? '60px' : '0'}">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="authService.isLoggedIn()"></app-footer>
